module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_chart-515dd4f174fff8cf4e1156c5ff9944aa.png";